import React from 'react';
import { useMediaQuery } from '../HooksPublic';

export interface HeroVideoProps {
	srcMobile: string;
	srcDesktop: string;
	className?: string;
	mobileClassName?: string;
	desktopClassName?: string;
}

const HeroVideo: React.FC<HeroVideoProps> = ({ 
	srcMobile, 
	srcDesktop, 
	className = 'hero-bg',
	mobileClassName = '',
	desktopClassName = ''
}) => {
	var isMobile = useMediaQuery('(max-width: 600px)');

	var videoClass = className;
	if (isMobile && mobileClassName) {
		videoClass += ` ${mobileClassName}`;
	} else if (!isMobile && desktopClassName) {
		videoClass += ` ${desktopClassName}`;
	}

	return (
		<video
			className={videoClass}
			src={isMobile ? srcMobile : srcDesktop}
			autoPlay
			loop
			muted
			playsInline
		/>
	);
};

export default HeroVideo;
